import React, {useState} from "react";
import dayjs from "dayjs";
import {IonCol, IonGrid, IonRow, IonButton} from "@ionic/react";
import {
  GET_MY_AGENCY_DETAILS,
  GET_MY_DETAIL,
} from "../../../graphql/queries/common.query";
import {
  GET_DYLOG_COMPANY_TYPES,
  GET_DYLOG_DOCUMENT_TYPES,
} from "../../../graphql/queries/dylog.query";

import {FileUpload} from "../../../components";
import {Accordion} from "../../../components";

import {useForm} from "react-hook-form";

import {useLazyQuery, useMutation} from "@apollo/client";
import {Breadcrumbs, Input, Select, DatePicker} from "../../../components";
import {
  UPDATE_MY_AGENCY,
  UPDATE_MY_DETAIL,
} from "../../../graphql/mutations/common.mutation";
import toast from "react-hot-toast";
import SelectWithSearch from "../../../components/SelectWithSearch";
import {yupResolver} from "@hookform/resolvers/yup";
import Loading from "../../../components/Loading";
import registrationSchema from "../../../lib/utils/validations/registration.valiadtion";
import {useSortedLazyQuery} from "../../../lib/services/updateProfile";
import _ from "lodash";
import {useHistory} from "react-router";

const DUMMY_PASSWORD = "8Digit@Secret";

const Profile = () => {
  const [isLoading, setLoading] = useState(false);
  const history = useHistory();

  const [clientTypeList, setClientTypeList] = React.useState([]);
  const [documentTypeList, setDocumentTypeList] = React.useState<any[]>([]);

  const [typonymList, setTyponymList] = React.useState<any[]>([]);
  const [provinceList, setProvinceList] = React.useState<any[]>([]);
  const [municpalityList, setMunicipalityList] = React.useState<any[]>([]);
  const [foreignCountryList, setForeignCountryList] = React.useState<any[]>([]);

  const [agency, setAgency] = React.useState<any>({});
  const [profile, setProfile] = React.useState<any>({});

  const [updateMyAgency] = useMutation(UPDATE_MY_AGENCY, {
    onCompleted(data) {
      if (data?.updateMyAgency?.errors) {
        toast.error(data.updateMyAgency.errors[0].message);
      }
    },
  });
  const [updateMyDetail] = useMutation(UPDATE_MY_DETAIL, {
    onCompleted(data) {
      if (data?.updateMyDetail?.errors) {
        toast.error(data.updateMyDetail.errors[0].message);
      }
      setValue("customer.password", DUMMY_PASSWORD);
      setValue("customer.repeatPassword", DUMMY_PASSWORD);
    },
  });

  const [getDylogMunicipalities] = useSortedLazyQuery(
    "municipalities",
    setMunicipalityList
  );
  const [getDylogProvinces] = useSortedLazyQuery("provinces", setProvinceList);
  const [getDylogForeignCountries] = useSortedLazyQuery(
    "foreignCountries",
    setForeignCountryList
  );
  const [getDylogTyponyms] = useSortedLazyQuery("typonyms", setTyponymList);

  const [showDocumentWarning, setShowDocumentWarning] =
    React.useState<boolean>(false);

  const [getPaginatedClientType] = useLazyQuery(GET_DYLOG_COMPANY_TYPES, {
    onCompleted(data) {
      if (data) {
        const tempData = data?.getCompanyTypes?.data ?? [];

        setClientTypeList(
          tempData
            ?.filter((itm: any) => itm.id !== ".")
            ?.map((item: any) => ({
              value: item.id,
              display: item.description,
            }))
        );
      }
    },
  });

  const [getPaginatedDocumentTypes] = useLazyQuery(GET_DYLOG_DOCUMENT_TYPES, {
    onCompleted(data) {
      const actualData =
        data.getDocumentTypes?.data?.map((itm: any) => ({
          value: itm.id,
          display: itm.description,
        })) ?? [];

      setDocumentTypeList(actualData);
    },
  });

  const [getMyAgency] = useLazyQuery(GET_MY_AGENCY_DETAILS, {
    onCompleted(data) {
      console.log(data.getMyAgency);
      setAgency(data.getMyAgency?.client);
    },
  });

  const [getMyDetails] = useLazyQuery(GET_MY_DETAIL, {
    onCompleted(data) {
      console.log(data.getMyDetail);
      setProfile(data.getMyDetail?.customer);
    },
  });

  const getNecessaryDetails = async () => {
    setLoading(true);
    await Promise.all([
      getPaginatedClientType(),
      getPaginatedDocumentTypes(),
      getMyAgency(),
      getMyDetails(),
      getDylogForeignCountries(),
      getDylogMunicipalities(),
      getDylogProvinces(),
      getDylogTyponyms(),
    ]);
    setLoading(false);
  };

  React.useEffect(() => {
    getNecessaryDetails();
  }, []);

  const asignCustomerValues = () => {
    for (const key of [
      "firstName",
      "lastName",
      "email",
      "mobileNumber",
      "notifiedBy",
    ]) {
      const value = profile?.[key];
      setValue(`customer.${key}`, value ?? null);
    }
    setValue("customer.password", DUMMY_PASSWORD);
    setValue("customer.repeatPassword", DUMMY_PASSWORD);
    setValue("customer.acceptedTerms", true);
  };

  const assignAgencyValues = async () => {
    for (const key of [
      "name",
      "representative",
      "documentNumber",
      "documentType",
      "postalCode",
      "expiresAt",
      "firstName",
      "lastName",
      "businessName",
      "fiscalCode",
      "vatNumber",
      "address",
      "houseNumber",
      "postalCode",
      "city",
      "province",
      "pecEmail",
      "sdiEmail",
      "email",
      "documents",
      "pecEmailAddress",
      "companyTypeId",
      "documentTypeId",
      "municipalityId",
      "regionId",
      "streetId",
      "dylogType",
    ]) {
      let value = agency[key];
      if (key === "expiresAt" && value) {
        const timestamp = Number(value);
        if (!isNaN(timestamp)) {
          value = new Date(timestamp).toISOString();
        }
      }
      setValue(`agency.${key}`, value ?? null);
    }
  };

  React.useEffect(() => {
    asignCustomerValues();
    assignAgencyValues();
  }, [profile, agency, clientTypeList, documentTypeList]);

  const {
    handleSubmit,
    register,
    setValue,
    getValues,
    control,
    watch,
    formState: {errors},
    clearErrors,
  } = useForm({
    resolver: yupResolver(registrationSchema),
  });

  const breadcrumbEntries = [
    {title: "Personale", link: "/personale"},
    {
      title: "Profilo",
    },
  ];

  const handleShowDocumentExpiryDate = (dateValue: string) => {
    const newDate = new Date();
    if (dayjs(dateValue).isBefore(newDate)) {
      setShowDocumentWarning(true);
    } else {
      setShowDocumentWarning(false);
    }
  };

  const handleRegister = async (data: any) => {
    const sanitizedData = _.cloneDeep(data);

    if (_.get(sanitizedData, "agency.postalCode")) {
      _.set(
        sanitizedData,
        "agency.postalCode",
        parseInt(sanitizedData.agency.postalCode)
      );
    }

    if (_.get(sanitizedData, "customer.password") === DUMMY_PASSWORD) {
      _.set(sanitizedData, "customer.password", null);
    }

    if (_.get(sanitizedData, "customer.repeatPassword") === DUMMY_PASSWORD) {
      _.set(sanitizedData, "customer.repeatPassword", null);
    }

    if (_.get(sanitizedData, "customer.mobileNumber")) {
      _.set(
        sanitizedData,
        "customer.mobileNumber",
        sanitizedData.customer.mobileNumber.toString()
      );
    }

    if (!_.get(sanitizedData, "agency.name")) {
      if (_.get(sanitizedData, "agency.businessName")) {
        _.set(sanitizedData, "agency.name", sanitizedData.agency.businessName);
      } else {
        _.set(
          sanitizedData,
          "agency.name",
          `${_.get(sanitizedData, "agency.firstName", "")} ${_.get(
            sanitizedData,
            "agency.lastName",
            ""
          )}`.trim()
        );
      }
    }

    if (!_.get(sanitizedData, "agency.pecEmailAddress")) {
      _.set(
        sanitizedData,
        "agency.pecEmailAddress",
        _.get(sanitizedData, "customer.pecEmail")
      );
    }

    _.set(
      sanitizedData,
      "agency.regionId",
      parseInt(_.get(sanitizedData, "agency.regionId"))
    );
    _.set(
      sanitizedData,
      "agency.municipalityId",
      parseInt(_.get(sanitizedData, "agency.municipalityId"))
    );

    try {
      await Promise.all([
        updateMyAgency({
          variables: {
            id: agency.id,
            ...sanitizedData.agency,
          },
        }),
        updateMyDetail({
          variables: {
            id: profile.id,
            ...sanitizedData.customer,
          },
        }),
      ]);
      toast.success("Profilo aggiornato con successo");
      history.push("/personale");
    } catch (err) {
      console.log(err);
    }
  };

  const DylogTypeAttribute = [
    {
      value: "C",
      description: "Privato",
    },
    {
      value: "D",
      description: "Ditta Individuale",
    },
    {
      value: "R",
      description: "Società",
    },
  ];

  const watchAccountType = watch("agency.dylogType");

  // if (isLoading) return <Loading />;

  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} />
      <div className="app-page-wrapper">
        <form onSubmit={handleSubmit(handleRegister)}>
          <Accordion title="Dati dell’account">
            <IonGrid>
              <IonRow>
                <IonCol size="12" size-sm="4">
                  <Input
                    name={"Nome*"}
                    registerName={`customer.firstName`}
                    register={register}
                    errors={errors}
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name={"Cognome*"}
                    registerName={`customer.lastName`}
                    register={register}
                    errors={errors}
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name="Indirizzo email*"
                    registerName={`customer.email`}
                    register={register}
                    errors={errors}
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name="Numero di telefono"
                    registerName={`customer.mobileNumber`}
                    register={register}
                    errors={errors}
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Select
                    name="Ricezione avanzamento ordine"
                    registerName={`customer.notifiedBy`}
                    register={register}
                    errors={errors}
                    multiple
                    requiredMessage={false}
                    options={[
                      {
                        value: "email",
                        display: "Email",
                      },
                      {
                        value: "sms",
                        display: "SMS",
                      },
                    ]}
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Select
                    name="Tipo cliente"
                    registerName={`agency.dylogType`}
                    register={register}
                    errors={errors}
                    onChange={(e) => {
                      setValue("agency.dylogType", e.target.value);
                    }}
                    options={DylogTypeAttribute?.map((itm: any) => ({
                      value: itm.value,
                      display: itm.description,
                    }))}
                    required
                  />
                </IonCol>
              </IonRow>
            </IonGrid>
          </Accordion>

          <Accordion title="Fatturazione ">
            <IonGrid>
              <IonRow>
                {watchAccountType === "C" && (
                  <>
                    <IonCol size="12" size-sm="4">
                      <Input
                        name={"Nome"}
                        registerName={`agency.firstName`}
                        register={register}
                        errors={errors}
                      />
                    </IonCol>

                    <IonCol size="12" size-sm="4">
                      <Input
                        name="Cognome"
                        registerName={`agency.lastName`}
                        register={register}
                        errors={errors}
                      />
                    </IonCol>
                  </>
                )}

                {watchAccountType !== "C" && (
                  <>
                    <IonCol size="12" size-sm="4">
                      <Input
                        name="Ragione sociale"
                        registerName={`agency.businessName`}
                        register={register}
                        errors={errors}
                      />
                    </IonCol>
                  </>
                )}

                <IonCol size="12" size-sm="4">
                  <Input
                    name="Codice Fiscale"
                    registerName={`agency.fiscalCode`}
                    register={register}
                    errors={errors}
                    type="text"
                  />
                </IonCol>

                {watchAccountType !== "C" && (
                  <IonCol size="12" size-sm="4">
                    <Input
                      name="Partita IVA"
                      registerName={`agency.vatNumber`}
                      register={register}
                      errors={errors}
                    />
                  </IonCol>
                )}

                <IonCol size="12" size-sm="4">
                  <SelectWithSearch
                    name="Toponimo"
                    registerName={`agency.streetId`}
                    register={register}
                    errors={errors}
                    options={typonymList}
                    hasSearch
                    setValue={setValue}
                    getValues={getValues}
                    watch={watch}
                    clearErrors={clearErrors}
                    required
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name={"Indirizzo (Via...)"}
                    registerName={`agency.address`}
                    register={register}
                    errors={errors}
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name={"Numero civico"}
                    registerName={`agency.houseNumber`}
                    register={register}
                    errors={errors}
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name="Cap"
                    registerName={`agency.postalCode`}
                    register={register}
                    errors={errors}
                    pattern={{
                      value: /\b\d{5}\b/,
                      message: "Cap non valido",
                    }}
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <SelectWithSearch
                    name="Città"
                    registerName={`agency.municipalityId`}
                    register={register}
                    errors={errors}
                    options={municpalityList}
                    hasSearch
                    setValue={setValue}
                    getValues={getValues}
                    watch={watch}
                    clearErrors={clearErrors}
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <SelectWithSearch
                    name="Provincia"
                    registerName={`agency.province`}
                    register={register}
                    errors={errors}
                    options={provinceList}
                    hasSearch
                    setValue={setValue}
                    getValues={getValues}
                    watch={watch}
                    clearErrors={clearErrors}
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <SelectWithSearch
                    name="Stato"
                    registerName={`agency.regionId`}
                    register={register}
                    errors={errors}
                    options={foreignCountryList}
                    hasSearch
                    setValue={setValue}
                    getValues={getValues}
                    watch={watch}
                    clearErrors={clearErrors}
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name={"Pec"}
                    registerName={`agency.pecEmail`}
                    register={register}
                    errors={errors}
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name={"SDI"}
                    registerName={`agency.sdiEmail`}
                    register={register}
                    errors={errors}
                  />
                </IonCol>

                <IonCol size="12" size-sm="4">
                  <Input
                    name={"Indirizzo Email per fatture"}
                    registerName={`agency.email`}
                    register={register}
                    errors={errors}
                  />
                </IonCol>
              </IonRow>
            </IonGrid>
          </Accordion>

          {watchAccountType !== "C" && (
            <Accordion title="Dati Rappresentante Legale">
              <IonGrid>
                <IonRow>
                  {/* <IonCol size="12" size-sm="4">
                  <Input
                    name={"Denominazione"}
                    registerName={`agency.name`}
                    register={register}
                    errors={errors}
                  />
                </IonCol> */}

                  <IonCol size="12" size-sm="4">
                    <Input
                      name="Legale rappresentante"
                      registerName={`agency.representative`}
                      register={register}
                      errors={errors}
                    />
                  </IonCol>

                  <IonCol size="12" size-sm="4">
                    <Input
                      name="N° documento, del legale rappresentante"
                      registerName={`agency.documentNumber`}
                      register={register}
                      errors={errors}
                    />
                  </IonCol>

                  <IonCol size="12" size-sm="4">
                    <DatePicker
                      name="Scadenza"
                      registerName={`agency.expiresAt`}
                      register={register}
                      control={control}
                      errors={errors}
                      onChange={handleShowDocumentExpiryDate}
                    />

                    {showDocumentWarning && (
                      <div className="app-input-wrapper">
                        <span>attenzione il documento risulta scaduto</span>
                      </div>
                    )}
                  </IonCol>

                  <IonCol size="12" size-sm="4">
                    <Select
                      name="Tipo società"
                      registerName={`agency.companyTypeId`}
                      register={register}
                      errors={errors}
                      options={clientTypeList}
                    />
                  </IonCol>

                  <IonCol size="12" size-sm="4">
                    <Select
                      name="Tipologia documento"
                      registerName={`agency.documentTypeId`}
                      register={register}
                      errors={errors}
                      options={documentTypeList}
                    />
                  </IonCol>
                </IonRow>

                <IonRow>
                  <IonCol size="12" size-sm="4">
                    <FileUpload
                      form={{
                        register: register,
                        registerName: "agency.documents",
                        errors: errors,
                        setValue: setValue,
                      }}
                      fieldName="Immagine della carta di identità"
                      defaultFiles={getValues("agency.documents")}
                    />
                  </IonCol>
                </IonRow>
              </IonGrid>
            </Accordion>
          )}

          {/* <Accordion title="Contatti">
            <IonGrid>
              <IonRow>
                <IonCol size="12" size-sm="4">
                  <Input
                    name={"Pec email"}
                    registerName={`agency.pecEmailAddress`}
                    register={register}
                    errors={errors}
                  />
                </IonCol>
              </IonRow>
            </IonGrid>
          </Accordion> */}

          <div className="flex-justify-between mb-default">
            <span />
            <IonButton
              shape="round"
              slot="end"
              size="default"
              className="login-button mb-default"
              type="submit"
            >
              Invia
            </IonButton>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Profile;
